import { otsBaseApi } from "../../ots-api";
import { FreightType } from "../../../model/freight-type";

const taggedBaseApi = otsBaseApi.enhanceEndpoints({ addTagTypes: ["FreightTypes"] });

const freightTypeApi = taggedBaseApi.injectEndpoints({
  endpoints: (builder) => ({
    getAllFreightTypes: builder.query<FreightType[], string | undefined>({
      query: (regionId) => ({
        url: `/freight-types/all`,
        method: "GET",
        params: regionId ? { regionId: regionId } : undefined
      }),
      keepUnusedDataFor: 300,
      providesTags: (result) => {
        if (result) {
          return [
            ...result.map(({ id }) => ({ type: "FreightTypes", id } as const)),
            { type: "FreightTypes", id: "LIST" }
          ];
        } else {
          return [{ type: "FreightTypes", id: "LIST" }];
        }
      }
    }),
    getFreightType: builder.query<FreightType, string>({
      query: (id) => ({
        url: `/freight-types/${id}`,
        method: "GET"
      }),
      keepUnusedDataFor: 300,
      providesTags: (result, error, id) => [{ type: "FreightTypes", id }]
    })
  })
});

export const {
  useGetAllFreightTypesQuery,
  useGetFreightTypeQuery
} = freightTypeApi;
